import { Boolean, Record } from 'runtypes';

export const ActivityExtrasRunType = Record({
	typeIsCall: Boolean,
});
